import { Cart, Identity, ResponseError } from '@ynap/api-utils';
import {
    ADD_MULTIPLE_TO_CART_REQUEST,
    ADD_MULTIPLE_TO_CART_SUCCESS,
    ADD_MULTIPLE_TO_CART_ERROR,
    NO_SIZE_SELECTED_ERROR,
    ADD_TO_CART_GENERIC_ERROR,
    ADD_TO_CART_IDENTITY_GENERIC_ERROR,
} from '../constants/ActionTypes';
import { SET_UBER_TOKEN, SET_UBER_TOKEN_ERROR } from '@ynap/auth-state';
import { raygun } from '@ynap/clientside-monitoring';
import { notificationActions } from '@ynap/notification-state';
import { getWatsonConfig } from '../selectors/getConfig';
import getLocale from '../selectors/getLocale';
import { notifyBasketChanged } from './common/siteFurnitureAPI';

const addMultipleToCart = (items, setActionNotificationOnError = true, addToCartLoading) => {
    return async (dispatch, getState, fetch) => {
        //to cover wcs perf issue
        if (addToCartLoading) {
            return;
        }
        const state = getState();
        const watsonConfig = getWatsonConfig(state);
        let { uberToken } = watsonConfig;
        const { messages } = state.appState;
        const addToBagErrorMessage = messages.notifications.ADD_TO_BAG_MESSAGE_ERROR();
        const isGuestUser = !uberToken;
        const { langId } = getLocale(state);

        if (!items || items?.length === 0) {
            return dispatch({ type: NO_SIZE_SELECTED_ERROR });
        }

        dispatch({ type: ADD_MULTIPLE_TO_CART_REQUEST });

        if (isGuestUser) {
            const guestIdentityRequest = Identity.createGuestIdentity(watsonConfig);
            try {
                const response = await fetch(guestIdentityRequest, { method: 'POST' });
                if (!response.ok) {
                    const errorResponse = new ResponseError(response);
                    raygun.helpers.agent('send', { error: errorResponse, tags: ['addMultipleToCart', 'guest-identity'] });
                    throw errorResponse;
                }
                const json = await response.json();

                uberToken = json.Ubertoken;
                // Set uberToken app-wide
                dispatch({ type: SET_UBER_TOKEN, uberToken });
            } catch (error) {
                dispatch({ type: SET_UBER_TOKEN_ERROR, error });
                // We are returning out so need to cancel the ADD_MULTIPLE_TO_CART_REQUEST
                dispatch({
                    type: ADD_MULTIPLE_TO_CART_ERROR,
                    items,
                    error: { errorKey: ADD_TO_CART_IDENTITY_GENERIC_ERROR },
                });
                return;
            }
        }

        try {
            return await addMultipleToCartWithUberToken(
                fetch,
                dispatch,
                { ...watsonConfig, items, uberToken, langId, includeShoppingCart: true },
                setActionNotificationOnError,
                addToBagErrorMessage,
                isGuestUser,
            );
        } catch (error) {
            return dispatch({
                type: ADD_MULTIPLE_TO_CART_ERROR,
                items,
                error: { errorKey: ADD_TO_CART_GENERIC_ERROR },
            });
        }
    };
};

const addMultipleToCartWithUberToken = async (fetch, dispatch, params, setActionNotificationOnError, addToBagErrorMessage) => {
    const addToCartRequest = Cart.addMultipleToCart(params);

    try {
        const response = await fetch(addToCartRequest);

        const json = await response.json();

        if (response.status === 400) {
            const { errors = [] } = json;
            let key = 'ADD_TO_CART_GENERIC_ERROR';
            if (errors.length > 0) {
                key = errors[0].errorKey;
            }
            if (setActionNotificationOnError === true) {
                dispatch(notificationActions.setNotification({ name: 'action', type: 'error', message: addToBagErrorMessage }));
            }
            return dispatch({
                type: ADD_MULTIPLE_TO_CART_ERROR,
                items: params.items,
                error: { errorKey: key },
            });
        }

        if (!response.ok) {
            const errorResponse = new ResponseError(response);
            raygun.helpers.agent('send', { error: errorResponse, tags: ['addMultipleToCart', 'add-to-cart'] });
            throw new ResponseError(response);
        }
        notifyBasketChanged(true, json, params.items[0]);
        return dispatch({ type: ADD_MULTIPLE_TO_CART_SUCCESS, lastAddedItems: params.items });
    } catch (error) {
        throw error;
    }
};

export default addMultipleToCart;
